import type * as PreferredCourses from '../types/PreferredCourses'

const generateCourseCardOptions = (valuesSet: string[]) =>
  valuesSet.map((val) => ({ label: val, value: val }))

export default function preferredCoursesComponentParser(
  rawComponent: PreferredCourses.Raw,
): PreferredCourses.Parsed {
  const {
    cards,
    regionLabelText,
    regionPlaceholderText,
    subjectLabelText,
    subjectPlaceholderText,
    ...rest
  } = rawComponent.preferredCourseCards

  // Get unique regions and subjects
  const { regions, subjects } = cards.reduce(
    (acc, { regions, subjects }) => {
      if (regions) {
        regions.forEach((region) => acc.regions.add(region))
      }
      if (subjects) {
        subjects.forEach((subject) => acc.subjects.add(subject))
      }
      return acc
    },
    { regions: new Set<string>(), subjects: new Set<string>() },
  )
  const filters = [
    {
      fieldId: 'subjects' as const,
      inputId: 'preferred-courses-subjects',
      label: subjectLabelText,
      options: generateCourseCardOptions(Array.from(subjects)),
      placeholder: subjectPlaceholderText,
    },
    {
      fieldId: 'regions' as const,
      inputId: 'preferred-courses-regions',
      label: regionLabelText,
      options: generateCourseCardOptions(Array.from(regions)),
      placeholder: regionPlaceholderText,
    },
  ]

  return {
    name: 'PreferredCourses',
    props: {
      ...rest,
      cards,
      filters,
    },
  }
}
